import {
  ChartBarIcon,
  Cog6ToothIcon,
  HomeIcon,
  ArchiveBoxArrowDownIcon,
  HomeModernIcon,
  ScaleIcon,
  TruckIcon,
  ArrowPathRoundedSquareIcon,
  ChartPieIcon,
  NewspaperIcon,
  WrenchIcon,
  LifebuoyIcon,
  TagIcon,
} from "@heroicons/react/24/outline";

import { isEmployeeUserType } from "./utility";
import { ArchiveBoxIcon } from "@heroicons/react/20/solid";

export default function routes(pathname, user_type) {
  var title;
  var routes;

  const isCFIA = user_type === 2;

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
    },
    {
      name: "Export label",
      href: "/export-label",
      icon: NewspaperIcon,
      current: false,
      showInMenu: isCFIA,
    },
    {
      name: "Receiving",
      icon: ArchiveBoxArrowDownIcon,
      current: false,
      showInMenu: !isCFIA,
      children: [
        { name: "Add new", href: "/receiving-invoices/new", current: false },
        { name: "History", href: "/receiving-invoices", current: false },
        { name: "Records", href: "/receiving-index", current: false },
      ],
    },
    {
      name: "Production",
      icon: HomeModernIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      children: [
        {
          name: "New Production",
          href: "/manufacture-product",
          current: false,
        },
        { name: "History", href: "/manufactured-products", current: false },
      ],
    },
    {
      name: "Production",
      icon: HomeModernIcon,
      current: false,
      showInMenu: isEmployeeUserType(),
      children: [
        {
          name: "Manufacture New",
          href: "/manufactured-products-employee",
          current: false,
        },
      ],
    },
    {
      name: "Packaging",
      icon: ScaleIcon,
      current: false,
      showInMenu: !isCFIA,
      children: [
        {
          name: "Package New",
          href: "/packaging-new",
          current: false,
        },
        { name: "History", href: "/packaging-reports", current: false },
      ],
    },
    {
      name: "Orders",
      icon: NewspaperIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      open: false,
      children: [
        { name: "Create", href: "/create-order" },
        { name: "Manage Orders", href: "/orders" },
      ],
    },
    {
      name: "Shipping",
      href: "/shippings",
      icon: TruckIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Inventory",
      icon: ScaleIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      children: [
        {
          name: "Raw Material",
          href: "/inventory-raw-material",
          current: false,
        },
        {
          name: "Manufactured",
          href: "/inventory-manufactured-material",
          current: false,
        },
        {
          name: "Pallet let down",
          href: "/pallet-let-down",
          current: false,
        },
      ],
    },
    {
      name: "Traceability",
      icon: ArrowPathRoundedSquareIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      children: [
        {
          name: "Manufactured",
          href: "/traceability/manufactured",
          current: false,
        },
        { name: "Supplier", href: "/traceability/supplier", current: false },
        {
          name: "Packaging Barcode Lookup",
          href: "/traceability/packaging-barcode",
          current: false,
        },
        {
          name: "Receiving Item Lookup",
          href: "/traceability/receiving-item",
          current: false,
        },
      ],
    },
    {
      name: "QA Reports",
      icon: ChartBarIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      children: [
        {
          name: "Reports",
          href: "/qa-reports",
          current: false,
        },
      ],
    },
    {
      name: "Recipes",
      href: "/recipes",
      icon: ChartPieIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
    },
    {
      name: "Products",
      href: "/my-products",
      icon: WrenchIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
    },
    {
      name: "Barcode Extractor",
      href: "/barcode-scanner",
      icon: TagIcon,
      current: false,
      showInMenu: !isCFIA && isEmployeeUserType(),
    },
    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      open: false,
      children: [
        {
          name: "Allergens",
          href: "/product-allergens",
          current: false,
        },
        { name: "Barcode Extractor", href: "/barcode-scanner", current: false },
        { name: "BOM items", href: "/bom-items", current: false },
        { name: "Brands", href: "/brands", current: false },
        {
          name: "Certification Types",
          href: "/certification-types",
          current: false,
        },
        { name: "Claims", href: "/product-claims", current: false },
        { name: "Customers", href: "/customers", current: false },
        { name: "Employees", href: "/employees", current: false },
        { name: "Media Manager", href: "/media-manager", current: false },
        { name: "Preservatives", href: "/preservatives", current: false },
        { name: "Production Costs", href: "/production-costs", current: false },
        { name: "Suppliers", href: "/suppliers", current: false },
        { name: "Supplier items", href: "/supplier-items", current: false },
        { name: "Types", href: "/product-types", current: false },
        { name: "Unit of measures", href: "/unit-of-measures", current: false },
        { name: "Quickbooks", href: "/quickbooks-login", current: false },
        { name: "Users", href: "/users", current: false },
      ],
    },
    {
      name: "Knowledge Base",
      href: "https://knowledge.qatrace.com/mrakovic-knowledge-base/",
      icon: LifebuoyIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Pallet let down",
      href: "/pallet-let-down",
      icon: ArchiveBoxIcon,
      current: false,
      showInMenu: !isCFIA && isEmployeeUserType(),
    },
  ];

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),

    title: title,
  };

  return returnArray;
}
